import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setTz } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tz, setTzState] = useState("America/New_York");

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/settings");
      setTz(data.display_tz);
      setTzState(data.display_tz);
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => { setUser(data); loadSettings(); })
      .catch(() => setUser(false));
  }, [loadSettings]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    loadSettings();
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const updateTz = (v) => { setTz(v); setTzState(v); };

  return <AuthCtx.Provider value={{ user, login, logout, tz, updateTz }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
